<template>
  <div>
    <hr />
    <h4>Parse (Stringify)</h4>
    <b-row>
      <b-col>
        <b-textarea
          v-model="jsonString"
          rows="15"
          class="word-input" />
      </b-col>
      <b-col cols="4">
          <b-card>
            <b-form-input 
                class="mb-2"
                v-model="jsonValue"
                placeholder="Enter sub property">
            </b-form-input>
          </b-card>
      </b-col>
    </b-row>
    
    
        <div class="code mt-5">
<pre>{{obj}}</pre>
        </div>

    <div class="frequency-chart">
      <canvas ref="frequencyChart" id="frequency-chart"></canvas>
    </div>
  </div>
</template>
<script>
export default {
    data() {
        return {
            jsonString: "",
            jsonValue: ""
        }
    },
    computed: {
        obj() {
            if (this.jsonString.length === 0) {
                return "";
            }

            try {
                let result = JSON.parse(this.jsonString);

                if (typeof result === 'string') {
                    result = JSON.parse(result);
                }

                if (this.jsonValue) {
                    result = result[this.jsonValue];

                    if (typeof result === 'string') {
                        result = JSON.parse(result);
                    }
                }

                return result;
            } catch(e) {
                console.log(e);
                return {
                    error: "Failed to parse"
                }
            }
        }
    }
}
</script>